import React, {Component} from 'react';
import {connect} from 'react-redux';
 import { NavbarItems } from 'react-bootstrap';

class GuestLayoutHeader extends Component {



    render() {
        return null;
    }
}

function mapStateToProps(state) {
    return { }
}

export default connect(mapStateToProps, {})(GuestLayoutHeader);
